import React from "react";

export const Divider = ({ color = "#00B488" }) => {
  return <div style={{ borderBottom: `1px solid color:"#00B488"` }} />;
};
